import { useMemo, useState } from 'react';
import { FailedInstance } from '../consistencyReportTypes';

const buildOrderedKeys = (instances: FailedInstance[]): string[] => {
  const keySet = new Set<string>();
  for (const inst of instances) {
    for (const key of Object.keys(inst)) keySet.add(key);
  }
  const keys = Array.from(keySet);
  return keys.includes('externalId')
    ? ['externalId', ...keys.filter((k) => k !== 'externalId')]
    : keys;
};

export const useFailedInstancesTable = (instances: FailedInstance[]) => {
  const orderedKeys = useMemo(() => buildOrderedKeys(instances), [instances]);
  const [hiddenColumns, setHiddenColumns] = useState<Set<string>>(new Set());

  const toggleColumn = (key: string) => {
    setHiddenColumns((prev: Set<string>) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const visibleKeys = orderedKeys.filter((k) => !hiddenColumns.has(k));

  return { orderedKeys, hiddenColumns, toggleColumn, visibleKeys };
};
